import { OwnershipMilestoneId } from './OwnershipMilestoneId';

export enum OwnershipMilestoneStatus {
  FORECAST = 'FORECAST',
  COMPLETE = 'COMPLETE',
  NOT_APPLICABLE = 'NOT_APPLICABLE',
}
export interface OwnershipMilestone {
  id: OwnershipMilestoneId;
  status: OwnershipMilestoneStatus;
  date: Date;
}
